import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing" className="py-24 px-4 bg-white relative overflow-hidden" data-id="element-172">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-warm-gradient p-10 md:p-16 rounded-[2.5rem] shadow-2xl border border-white" data-id="element-174">
          <h2 className="text-3xl md:text-5xl font-bold text-brown mb-6" data-id="element-175">
            Da el primer paso hacia días más tranquilos
          </h2>
          <p className="text-xl text-brown-light mb-10 max-w-2xl mx-auto" data-id="element-176">
            Una inversión menor para una transformación mayor en tu hogar.
          </p>

          <div className="flex items-center justify-center gap-4 mb-10" data-id="element-177">
            <span className="text-xl font-medium text-brown-light/50 line-through" data-id="element-178">
              $19,99
            </span>
            <span className="text-5xl md:text-6xl font-bold text-terracotta" data-id="element-179">
              $6.39
            </span>
            <span className="inline-flex items-center px-3 py-1 text-sm font-semibold text-green-700 bg-green-100 border border-green-200 rounded-full" data-id="element-180">
              66% OFF
            </span>
          </div>

          <motion.a href="https://novarapress.com/cart/46289057742988:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="w-full md:w-auto px-10 py-5 bg-terracotta text-white rounded-full font-bold text-xl shadow-lg shadow-terracotta/30 hover:bg-terracotta-dark transition-colors flex items-center justify-center gap-3 mx-auto mb-6 cursor-pointer" data-id="element-181">
            Da el primer paso hacia la paz
            <ArrowRight className="w-6 h-6" data-id="element-182" />
          </motion.a>

          <div className="flex items-center justify-center gap-2 text-sm text-brown-light opacity-80" data-id="element-183">
            <ShieldCheck className="w-4 h-4" data-id="element-184" />
            <span data-id="element-185">Pago seguro y acceso inmediato</span>
          </div>
        </motion.div>
      </div>
    </section>;
}